import React, { useState } from 'react';
import './CaseCard.scss';
import arrow from '../../assets/images/Arrow.svg';
import arm from '../../assets/images/Arm.svg';
import { useNavigate } from 'react-router-dom';
import 'react-lazy-load-image-component/src/effects/blur.css';

const CaseCard = (props) => {
  const [pageLoading, setPageLoading] = useState(false);
  const navigate = useNavigate();
  const hasExternalLink = Boolean(props.externalLink);

  const handleCardClick = (event) => {
    event.preventDefault();

    if (props.nda || (!props.exist && !hasExternalLink)) {
      return;
    }

    if (hasExternalLink) {
      window.open(props.externalLink, '_blank', 'noopener,noreferrer');
      return;
    }

    setPageLoading(true);
    navigate(`/${props.path}`);

    // setTimeout(() => {
    //   navigate(`/${props.exist ? props.path : '#'}`);
    // }, 2000);
  };

  return (
    <div className="case-card-link" onClick={handleCardClick}>
      <div
        className={`case-card ${
          (!props.exist && !hasExternalLink) || props.nda ? 'case-card_disabled' : ''
        }`}
      >
        {/* <div className={`case-card__image-box ${pageLoading ? 'full-size-card' : ''}`}> */}
        <div className={`case-card__image-box`}>
          <img
            src={props.image}
            alt={props.alt}
            className={`${pageLoading ? 'full-size' : 'case-card__image'}`}
          />
          {/* <img src={props.image} alt={props.alt} className={`case-card__image`}/> */}
        </div>
        <div className="case-card__text-container">
          <div className="">
            <h2>{props.title}</h2>
            <p>{props.text}</p>
          </div>
          {props.exist && (
            <span className="case-card__link case-card__link_exist">
              <img src={arrow} alt="arrow" />
              <p>VIEW PROJECT</p>
            </span>
          )}
          {hasExternalLink && (
            <a
              className="case-card__link case-card__link_exist"
              href={props.externalLink}
              target="_blank"
              rel="noreferrer"
              onClick={(event) => event.stopPropagation()}
            >
              <img src={props.showLock ? arm : arrow} alt={props.showLock ? 'lock' : 'arrow'} />
              <p>{props.externalLabel || 'VIEW PROJECT'}</p>
            </a>
          )}
          {!props.exist && !props.nda && !hasExternalLink && (
            <span className="case-card__link">
              {props.showLock && <img src={arm} alt="lock" />}
              COMING SOON
            </span>
          )}
          {props.nda && (
            <span className="case-card__link">
              <img src={arm} alt="arm" />
              UNDER NDA
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseCard;
